import { RealityCheckActionConstants } from "../action-constants/index.js";

const showPopup = netLossAmount => ({
  type: RealityCheckActionConstants.SHOW_POPUP,
  payload: netLossAmount
});

const hidePopup = () => ({
  type: RealityCheckActionConstants.HIDE_POPUP
});

const setSportSessionDetails = sportSessionDetails => ({
  type: RealityCheckActionConstants.SET_SPORT_SESSION_DETAILS,
  payload: sportSessionDetails
});

export default {
  showPopup,
  hidePopup,
  setSportSessionDetails
};
